import { COLORS } from '@avalara/bat-apps-shared/constants';
import styled from 'styled-components';

import ExternalLink from '../../external-link';

import type { Content } from '../../../../../types';

const TrialTileWrapper = styled.div`
  border: 1px solid ${COLORS.lightBlue};
  border-radius: 3px;
  height: 305px;
  width: 310px;
  padding: 30px;
  margin: 30px;

  h1 {
    color: ${COLORS.grayBlack};
    line-height: 29px;
    font-size: 23px;
    padding-bottom: 20px;
  }

  p {
    color: ${COLORS.grayBlack};
    line-height: 24px;
    padding-bottom: 20px;
  }

  @media (min-width: 1041px) {
    min-width: 305px;
  }
  @media (max-width: 1260px) {
    min-width: 330px;
  }
  @media (max-width: 1040px) {
    min-width: 355px;
  }
  @media (max-width: 765px) {
    min-width: 405px;
  }
  @media (max-width: 599px) {
    min-width: 0px;
  }
`;

const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  a.button {
    height: 30px;
    line-height: 20px;
  }
`;

const TrialTile = ({ title, textContent, buttonText, link }: Content) => (
  <TrialTileWrapper>
    <div>
      <h1>{title}</h1>
      <p className='margin-top-md'>{textContent}</p>
    </div>
    <ButtonWrapper>
      <ExternalLink className='button secondary margin-top-md' href={link}>
        {buttonText}
      </ExternalLink>
    </ButtonWrapper>
  </TrialTileWrapper>
);

export default TrialTile;
